import AppToast from '../ui/AppToast';

const ValidateForm = (form) => {
  const validate = (obj) => {
    if (obj.required) {
      if (String(obj.value).trim() === '') {
        return false;
      }
    }
    return true;
  };

  let success = true;
  for (var key in form) {
    if (form.hasOwnProperty(key)) {
      if (validate(form[key]) === false) {
        success = false;
        console.log('obligatorios ', form[key]);
        break;
      }
    }
  }

  if (success === false) {
    AppToast('Los campos marcados con (*) son obligatorios', success);
  }

  return success;
};

export default ValidateForm;
